// Lets the prerender script seed data synchronously before renderToString()
// runs, so components can read it from a useState lazy initializer instead
// of only via useEffect (which never fires during SSR).
//
// The client bundle is a SEPARATE copy of this module with its own empty
// Map — seeding the server-side instance has no effect on it. Without
// bridging the two, the client's first render would start from empty state
// while the server-rendered HTML already has real content, and React would
// reject the mismatch and throw away the prerendered markup entirely. So on
// the client we seed this store from `window.__SSR_CACHE__`, a small JSON
// blob the prerender script embeds in the page — see
// scripts/prerender.mjs and the inline script it injects before `</body>`.
declare global {
  interface Window {
    __SSR_CACHE__?: Record<string, unknown>
  }
}

const store = new Map<string, unknown>(
  typeof window !== 'undefined' && window.__SSR_CACHE__
    ? Object.entries(window.__SSR_CACHE__)
    : [],
)

export const ssrCache = {
  has(key: string): boolean {
    return store.has(key)
  },
  get<T>(key: string): T | undefined {
    return store.get(key) as T | undefined
  },
  set(key: string, value: unknown): void {
    store.set(key, value)
  },
  clear(): void {
    store.clear()
  },
  /** Plain-object snapshot for embedding in the prerendered HTML. Server-only. */
  toJSON(): Record<string, unknown> {
    return Object.fromEntries(store)
  },
}
